<div class="bmarkSpotRiskTotalsContainer" *ngIf="isZero === false; else showZero">
  <span
    [ngClass]="{ 'bmarkSpotRiskAmtNegative' : isNegative === true, 'bmarkSpotRiskAmtPositive': isNegative === false }"
  >
    {{amountText}} {{materialSuffix ? ' Oz' : ''}}
  </span>
</div>

<ng-template #showZero>
  <span>{{displayEmpty? '-' : '&nbsp;'}}</span>
</ng-template>
